// Module
var code = "<store-settings on-success=\"onSuccess\" on-error=\"onError\"/> ";
// Exports
var _module_exports = code;;
var path = '/admin/store/settings.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;